import PropTypes from "prop-types";
import LeftArrowIcon from "images/left-arrow.svg";

const SurveyItemHeader = ({ title, subtitle, closeFeedbackScreen }) => {
  return (
    <div>
      <div className="flex justify-between items-center mt-4">
        <button className="cursor-pointer pl-6 pr-6" onClick={closeFeedbackScreen}>
          <LeftArrowIcon className="w-2" />
        </button>
        <span className="text-h4 font-semibold">{title}</span>
        <button className="underline font-semibold pr-4" onClick={closeFeedbackScreen}>
          Cancel
        </button>
      </div>
      <p className="text-darkGray text-center my-3 mx-8">{subtitle}</p>
      <hr className="border-t border-lighterGray" />
    </div>
  );
};

SurveyItemHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  closeFeedbackScreen: PropTypes.func.isRequired,
};

export default SurveyItemHeader;
